import { render, staticRenderFns } from "./MerAndChannelTypeDayBills.vue?vue&type=template&id=4ca009a4"
import script from "./MerAndChannelTypeDayBills.vue?vue&type=script&lang=ts"
export * from "./MerAndChannelTypeDayBills.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports